<template>
  <!-- eslint-disable max-len -->
  <div class="content">
    <h1>Art</h1>

    <p>Alongside my work as an interior designer, I also love creating landscape and waterscape
      paintings. I&apos;m calmed by nature&mdash;the time I spend reflecting outdoors always inspires me.
      My way of honoring this experience is by slowing down, really looking, and simplifying the
      beauty I see. By using a more limited palette in my paintings, I strive to convey a scene
      that brings you a sense of serenity and ease. I love traveling and experiencing firsthand
      all the natural beauty the world has to offer.  Discovering different perspectives around
      the globe informs my sense of beauty and adds depth to the landscapes I create. While
      traveling engages my adventurous and curious spirit, I also enjoy returning to the comforts
      of my home in Minneapolis, Minnesota.</p>

    <p>You can view my <a href="https://art.cenaobrien.com/">entire portfolio</a> and
    <a href="https://www.etsy.com/shop/CenaOBrien">visit my shop</a> to purchase paintings that are
      currently available.</p>

    <div class="photos">
      <div class="image-container" :style="{ backgroundImage: 'url(' + require('../../assets/img/art1.jpg') + ')' }"></div>
      <div class="image-container" :style="{ backgroundImage: 'url(' + require('../../assets/img/art3.jpg') + ')' }"></div>
      <div class="image-container" :style="{ backgroundImage: 'url(' + require('../../assets/img/art2.jpg') + ')' }"></div>
      <div
        class="image-container"
        :style="{ backgroundPosition: 'top', backgroundImage: 'url(' + require('../../assets/img/art4.jpg') + ')' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Art',
};
</script>

<style scoped lang="scss">
.photos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .image-container {
    background-position: center;
    background-size: cover;
    margin: 0.5rem;
    display: inline-block;
    width: 300px;
    height: 300px;
  }
}
</style>
